
export class EventTracker {
    constructor() {
        // I'm just gunna keep it [4, 3, 2, 1]

        this.#generateEventIndicators();
    }

    // flex space between...inner flex space between?
    #generateEventIndicators() {

        const eventLengthAndOccurance = [
            { len: 4, numOcc: 1},
            { len: 3, numOcc: 2},
            { len: 2, numOcc: 3},
            { len: 1, numOcc: 4},
        ]

        const eventTrackerEl = document.querySelector('.event-tracker');

        this.eventIndicatorButtonsFlatArr = [];

        for (let i = 0; i < eventLengthAndOccurance.length; i++) {
            let eventLengthAndOccI = eventLengthAndOccurance[i];

            const eventLenRowEl = document.createElement('div');

            eventLenRowEl.classList.add('event-len-row');

            eventTrackerEl.appendChild(eventLenRowEl);

            const eventLength = eventLengthAndOccI.len;
            const numOccurances = eventLengthAndOccI.numOcc;

            for (let j = 0; j < numOccurances; j++) {
                // create button
                const indicatorButtonEl = document.createElement('div');
                indicatorButtonEl.classList.add('indicator-button');
                indicatorButtonEl.classList.add('indicator-btn-toggled-on');

                eventLenRowEl.appendChild(indicatorButtonEl);

                // create days within button
                for (let d = 0; d < eventLength; d++) {
                    let eventDayEl = document.createElement('div');
                    eventDayEl.classList.add('indicator-event-day');

                    let occupiedBoxEl = document.createElement('div');
                    occupiedBoxEl.classList.add('indicator-occupied-box');
                    eventDayEl.appendChild(occupiedBoxEl);

                    indicatorButtonEl.appendChild(eventDayEl);
                }

                this.eventIndicatorButtonsFlatArr.push(indicatorButtonEl);

                // and toggle!
                indicatorButtonEl.addEventListener('click', (e) => {
                    if (indicatorButtonEl.classList.contains('indicator-btn-toggled-on')){
                        indicatorButtonEl.classList.remove('indicator-btn-toggled-on')
                    }
                    else {
                        indicatorButtonEl.classList.add('indicator-btn-toggled-on')
                    }
                });
            }
        }
    }

    disableButtons() {
        for (let i = 0; i < this.eventIndicatorButtonsFlatArr.length; i++) {
            const indicatorButtonEl = this.eventIndicatorButtonsFlatArr[i];

            if (indicatorButtonEl.classList.contains('indicator-btn-toggled-on')){
                indicatorButtonEl.classList.remove('indicator-btn-toggled-on')
            }

            indicatorButtonEl.classList.add('indicator-btn-disabled');
        }
    }
}